import { compose } from 'redux';
import { connect } from 'react-redux';
import { PureComponent } from 'react';
import { Grid, Divider } from '@material-ui/core';
import withStyles from '@material-ui/styles/withStyles';
import { matchPath, Redirect, Switch } from 'react-router-dom';

import {
  Menu,
  MenuHeader,
  LoadingOverlay,
  RouteContainer,
  MenuNavigationItem,
  withToggleModal,
} from 'altus-ui-components';

import {
  getSystemRoles,
  createSystemRoleOnSubmit,
} from 'authorization/authorization.actions';

import {
  AUTHORIZATION_ACTIONS,
  CREATE_SYSTEM_ROLE_MODAL_ID,
} from 'authorization/authorization.constants';

import { EMPTY_LIST } from 'app/app.constants';
import { toSystemRole } from 'utils/route.util';
import { getActionDataStateFromState } from 'app/app.selectors';
import NoRoleSelectedPage from 'features/settings/accessRoles/NoRoleSelectedPage';
import { getSystemRolesListFromState } from 'authorization/authorization.selectors';
import CreateSystemRoleModal from 'features/settings/accessRoles/systemRoles/CreateSystemRoleModal';

class SystemRolesContainer extends PureComponent {
  componentDidMount() {
    const { dispatchGetSystemRoles } = this.props;

    dispatchGetSystemRoles();
  }

  onAdd = () => {
    const { dispatchToggleModal } = this.props;
    dispatchToggleModal({ modalId: CREATE_SYSTEM_ROLE_MODAL_ID });
  };

  renderMenuItem = (systemRole) => {
    const { pathname } = this.props;

    // use the current path, and replace the base url with the correct role url
    const match = matchPath(pathname, {
      path: '/v2/settings/access-roles/system/:systemRoleId',
    });

    if (!match) return null;

    const roleId = systemRole.get('roleId');
    const systemRoleUrl = toSystemRole(roleId);

    const to = pathname.replace(match.url, systemRoleUrl);

    return (
      <MenuNavigationItem to={to} title={systemRole.get('name')} key={roleId} />
    );
  };

  render() {
    const {
      path,
      routes,
      classes,
      dataState,
      systemRoles,
      dispatchCreateSystemRoleOnSubmit,
    } = this.props;

    return (
      <Grid container item xs wrap="nowrap" className={classes.root}>
        <Grid container item direction="column" xs={2} wrap="nowrap">
          <MenuHeader onAdd={this.onAdd} title="Role" />
          <Divider />
          <Grid item container className={classes.menuContainer}>
            <Grid item xs>
              <Menu
                items={systemRoles}
                renderMenuItem={(item) => this.renderMenuItem(item)}
              />
            </Grid>
          </Grid>
        </Grid>
        <Divider orientation="vertical" flexItem />
        <Switch>
          {!!systemRoles.size && (
            <Redirect
              exact
              from={path}
              to={toSystemRole(systemRoles.getIn([0, 'roleId']))}
            />
          )}
          <RouteContainer
            routes={routes}
            MissingRouteComponent={NoRoleSelectedPage}
          />
        </Switch>
        <CreateSystemRoleModal onSubmit={dispatchCreateSystemRoleOnSubmit} />
        <LoadingOverlay dataState={dataState} timeout={0} />
      </Grid>
    );
  }
}

SystemRolesContainer.defaultProps = {
  systemRoles: EMPTY_LIST,
};

const styles = () => ({
  root: {
    overflow: 'hidden',
  },
  menuContainer: {
    overflow: 'auto',
  },
});

export default compose(
  withToggleModal,
  connect(
    (state) => ({
      systemRoles: getSystemRolesListFromState(state),
      dataState: getActionDataStateFromState(
        state,
        AUTHORIZATION_ACTIONS.GET_SYSTEM_ROLES,
      ),
    }),
    {
      dispatchGetSystemRoles: getSystemRoles,
      dispatchCreateSystemRoleOnSubmit: createSystemRoleOnSubmit,
    },
  ),
  withStyles(styles),
)(SystemRolesContainer);
